import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import AboutSection from './components/AboutSection';
import HowItWorks from './components/HowItWorks';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import StatsSection from './components/StatsSection';
import { useJsonLd } from '@/hooks/useJsonLd';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '') ?? '';

  usePageMeta({ canonical: '/' });

  useJsonLd([
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Flow & Glow',
      url: siteUrl || 'https://flowundglow.de',
      description: 'Kosmetische Zahnaufhellung in Köln – schmerzfrei & professionell mit PAP-Technologie, ab 99€.',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'HealthAndBeautyBusiness',
      name: 'Flow & Glow',
      description: 'Kosmetische Zahnaufhellung in Köln – schmerzfrei & professionell mit PAP-Technologie, ab 99€. Peroxidfrei, schonend, strahlend.',
      url: siteUrl || 'https://flowundglow.de',
      email: 'hallo@flowundglow.de',
      telephone: '+49 221 0000000',
      priceRange: '€€',
      image: `${siteUrl || 'https://flowundglow.de'}/og-image.jpg`,
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Köln',
        addressRegion: 'NW',
        addressCountry: 'DE',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 50.9333,
        longitude: 6.9500,
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5.0',
        reviewCount: '47',
        bestRating: '5',
        worstRating: '1',
      },
      review: [
        {
          '@type': 'Review',
          author: { '@type': 'Person', name: 'Katharina M.' },
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
          reviewBody: 'Ich hab vorher echt gezögert, weil ich sehr empfindliche Zähne habe. Bei Jenny hatte ich null Schmerzen. Das Ergebnis war direkt nach der Anwendung sichtbar, in gerade mal 60 Minuten.',
          datePublished: '2026-03-28',
        },
        {
          '@type': 'Review',
          author: { '@type': 'Person', name: 'Lena S.' },
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
          reviewBody: '45 Minuten, entspannt auf einer bequemen Liege – und danach Zähne, die ich kaum wiedererkannt hab. Kein Brennen, kein Ziehen, nichts.',
          datePublished: '2026-03-05',
        },
        {
          '@type': 'Review',
          author: { '@type': 'Person', name: 'Sophie T.' },
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
          reviewBody: 'Jenny hat sich vorher Zeit genommen, die Ausgangsfarbe analysiert und mir erklärt, was realistisch ist. Das Ergebnis: perfekt. Genau das, was ich wollte.',
          datePublished: '2026-01-15',
        },
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '10:00',
          closes: '19:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '10:00',
          closes: '16:00',
        },
      ],
      sameAs: ['https://www.instagram.com/flowundglow'],
    },
  ]);

  return (
    <main className="font-sans">
      <Navbar />
      <HeroSection />
      <TrustBar />
      <StatsSection />
      <ServicesOverview />
      <AboutSection />
      <HowItWorks />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}
